export enum LoginActions {
    SET_LOGIN_ERROR = "setLoginError",
    CLEAR_ERR = "clearErr",
    SET_ACTIVATION_MESSAGE ="setLoginActivationMessage",
    TOGGLE_PASS_RESET= "togglePassReset"
}